/* unplugin-vue-components disabled */import { render } from "./PurchaseTokens.vue?vue&type=template&id=7a418ad0&scoped=true"
import script from "./PurchaseTokens.vue?vue&type=script&lang=js"
export * from "./PurchaseTokens.vue?vue&type=script&lang=js"

import "./PurchaseTokens.vue?vue&type=style&index=0&id=7a418ad0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a418ad0"]])

export default __exports__